import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./core/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'contato-assistencial',
    loadChildren: () => import('./modules/contato-assistencial/contato-assistencial.module').then(m => m.ContatoAssistencialPageModule)
  },
  {
    path: 'contato-assistencial/:id/edit',
    loadChildren: () => import('./modules/contato-assistencial/contato-assistencial.module').then(m => m.ContatoAssistencialPageModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./core/home/home.module').then( m => m.HomePageModule)
  },
  {
    path: 'busca-modal',
    loadChildren: () => import('./modals/busca-modal/busca-modal.module').then( m => m.BuscaModalPageModule)
  },
  {
    path: 'modal-select',
    loadChildren: () => import('./shared/modals/modal-select/modal-select.module').then( m => m.ModalSelectPageModule)
  },
  {
    path: 'modal-select-terminologia',
    loadChildren: () => import('./shared/modals/modal-select-terminologia/modal-select-terminologia.module').then( m => m.ModalSelectTerminologiaPageModule)
  },
  {
    path: 'modal-select-profissional',
    loadChildren: () => import('./shared/modals/modal-select-profissional/modal-select-profissional.module').then( m => m.ModalSelectProfissionalPageModule)
  },
  {
    path: 'modal-select-procedimento',
    loadChildren: () => import('./shared/modals/modal-select-procedimento/modal-select-procedimento.module').then( m => m.ModalSelectProcedimentoPageModule)
  },
  {
    path: 'modal-filter',
    loadChildren: () => import('./shared/modals/modal-filter-contato-assistencial/modal-filter-contato-assistencial.module').then( m => m.ModalFilterContatoAssistencialPageModule)
  },
  {
    path: 'modal-filter-importacao',
    loadChildren: () => import('./shared/modals/modal-filter-importacao/modal-filter-importacao.module').then( m => m.ModalFilterImportacaoPageModule)
  },
  {
    path: 'modal-profissional',
    loadChildren: () => import('./shared/modals/modal-profissional/modal-profissional.module').then( m => m.ModalProfissionalPageModule)
  },
  {
    path: 'modal-add-profissional',
    loadChildren: () => import('./shared/modals/modal-add-profissional/modal-add-profissional.module').then( m => m.ModalAddProfissionalPageModule)
  },
  {
    path: 'painel-geral',
    loadChildren: () => import('./modules/painel-geral/painel-geral.module').then( m => m.PainelGeralPageModule)
  },
  {
    path: 'relatorios',
    loadChildren: () => import('./modules/relatorios/relatorios.module').then( m => m.RelatoriosPageModule)
  },
  {
    path: 'modal-ciente',
    loadChildren: () => import('./shared/modals/modal-ciente/modal-ciente.module').then( m => m.ModalCientePageModule)
  }

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {preloadingStrategy: PreloadAllModules, useHash: true,  onSameUrlNavigation: 'reload'})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
